module.exports = __webpack_public_path__ + "static/img/label-icon3.922307c7.png";